import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DialogUsersModule } from './dialogs/detail/dialog-users.module';
import { FilterUsersModule } from './filter/filter-users.module';
import { UsersApi } from './services/api/users-api.service';
import { UsersService } from './services/users-resolver.service';
import { UsersComponent } from './users.component';


const routes: Routes = [
  {
    path: 'usuarios',
    component: UsersComponent,
    canActivate: [
      AuthenticatedGuard,
    ],
    data: { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.USERS' }
  }
];

@NgModule({
  declarations: [
    UsersComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseSharedModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSortModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule,
    FilterUsersModule,
    DialogUsersModule,
    ExportDialogModule,
  ],
  providers: [UsersService, UsersApi]
})

export class UsersModule {
}
